import {BuildingLevelData} from "../index";

export function aggregateBuildingLevels(levelData: BuildingLevelData[], previousLevel?: BuildingLevelData) {
    const aggregatedRow = Object.values(levelData)
        .sort((a, b) => a.level - b.level)
        .reduce((aggregatedData, data) => {
                if (aggregatedData === null) {
                    return JSON.parse(JSON.stringify(data)) as BuildingLevelData;
                }
                aggregatedData.resourceCost.r1 += data.resourceCost.r1;
                aggregatedData.resourceCost.r2 += data.resourceCost.r2;
                aggregatedData.resourceCost.r3 += data.resourceCost.r3;
                aggregatedData.resourceCost.r4 += data.resourceCost.r4;
                aggregatedData.buildingTime += data.buildingTime;
                return aggregatedData;
            },
            null
        );
    if (aggregatedRow !== null) {
        const baseLevel = previousLevel !== null ? previousLevel : {
            population: 0,
            supply: 0,
            culturePoints: 0
        };
        const targetLevel = levelData[levelData.length - 1];
        aggregatedRow.population = targetLevel.population - baseLevel.population;
        aggregatedRow.supply = targetLevel.supply - baseLevel.supply;
        aggregatedRow.culturePoints = targetLevel.culturePoints - baseLevel.culturePoints;
    }
    return aggregatedRow;
}
